import { useDispatch, useSelector } from 'react-redux';
import { isBefore, parseISO } from 'date-fns';
import { getCreateNudataSession } from 'stash/actions';
import { selectNudataSession } from 'stash/selectors';
import { useEffect } from 'react';

const NudataHook = () => {
	const dispatch = useDispatch();
	const nudataSession = useSelector(selectNudataSession);
	const currentTime = new Date();
	const expiresAt = parseISO(nudataSession?.expiresAt);
	const isSessionExpired = nudataSession?.id ? isBefore(expiresAt, currentTime) : false;
	const nudataQueryParams = nudataSession?.id
		? `&nudata_session_id=${nudataSession.id}&nudata_session_expires_at=${nudataSession.expiresAt}&nudata_session_hash=${nudataSession.hash}`
		: '';

	useEffect(() => {
		if (isSessionExpired) {
			dispatch(getCreateNudataSession());
		}
	}, [isSessionExpired, dispatch]);

	return {
		nudataQueryParams,
		nudataSession,
	};
};

export default NudataHook;
